import React, { useState, useEffect } from "react";
import { FormField, Select } from "semantic-ui-react";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { app } from "../../app/config/firebase";

const db = getFirestore(app);

export default function ExpireFormSelect({ selectedState, selectedForm, onFormChange }) {
  const [formOptions, setFormOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let isMounted = true; // Flag to track if component is still mounted

    const fetchForms = async () => {
      if (!selectedState) {
        if (isMounted) {
          setFormOptions([]);
        }
        return;
      }

      if (isMounted) {
        setLoading(true);
      }

      try {
        const formsRef = collection(db, `forms${selectedState}`);
        const formsQuery = query(
          formsRef,
          where("dontShowFormInAddDocumentModal", "==", false)
        );
        const snapshot = await getDocs(formsQuery);

        if (isMounted) {
          const options = snapshot.docs
            .map((doc) => ({
              key: doc.id,
              value: doc.id,
              text: doc.data().title,
            }))
            .sort((a, b) => a.text.localeCompare(b.text));

          setFormOptions(options);
        }
      } catch (error) {
        console.error("Error fetching forms:", error);
        if (isMounted) {
          setFormOptions([]);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchForms();

    // Cleanup function to prevent state updates on unmounted component
    return () => {
      isMounted = false;
    };
  }, [selectedState]);

  return (
    <FormField>
      <label>Select Form to Expire</label>
      <Select
        placeholder="Select a form..."
        value={selectedForm || null}
        options={formOptions}
        onChange={(e, { value }) => onFormChange(value)}
        loading={loading}
        disabled={!selectedState || loading}
        search
        clearable
      />
    </FormField>
  );
}
